import styles from './CreateApp.module.less'

import { useState, useEffect } from 'react'
import { Layout, Steps } from '@haier/bwd'
import { MicroEvent } from '@aicoding/micro-bridge'
// import LeftOutlined from '@haier/icons/LeftOutlined'
// import RightOutlined from '@haier/icons/RightOutlined'
import { useSiderCollapse } from '@/hooks/useSiderCollapse'
import { Loading } from '@haier/bwd'
import { useWorkflow } from '@/hooks/useWorkflow'
import microApp from '@micro-zoe/micro-app'
import Logo from '@/assets/Logo'
import MenuUnfoldOutlined from '@haier/icons/MenuUnfoldOutlined'
import MenufoldOutlined from '@haier/icons/MenufoldOutlined'
import { normalizeMicroAppUrl } from '@/utils/microAppUrl'

const CreateApp = () => {
  const { loading, processInfo } = useWorkflow()
  const { collapsed, toggle } = useSiderCollapse()
  const [current, setCurrent] = useState(0)

  const instance = processInfo?.instances[current]
  const { instances: _, ...processBase } = processInfo ?? {}
  const microData = { ...processBase, instance }

  // 转换微应用 URL，使用代理路径避免 CORS（开发环境）
  const normalizedUrl = normalizeMicroAppUrl(instance?.nodeConfig.url)

  const items =
    processInfo?.instances.map((instance) => ({
      title: collapsed ? undefined : instance.instanceName,
      name: instance.nodeConfig.name,
    })) ?? []

  const handleNavigateNext = () => {
    setCurrent(current < items.length - 1 ? current + 1 : current)
  }
  const handleNavigateBack = () => {
    setCurrent(current > 0 ? current - 1 : current)
  }

  const navigationHandlers = new Map<MicroEvent, (data: unknown) => void>([
    [MicroEvent.NAVIGATE_NEXT, handleNavigateNext],
    [MicroEvent.NAVIGATE_BACK, handleNavigateBack],
  ])

  useEffect(() => {
    // 启动微应用框架
    microApp.start()
  }, [])

  useEffect(() => {
    if (instance?.nodeConfig.name) microApp.setData(instance.nodeConfig.name, microData)
  }, [microData])

  useEffect(() => {
    const name = instance?.nodeConfig.name

    const dataHandler = (data: { type: MicroEvent; data: unknown }) => {
      const handler = navigationHandlers.get(data.type)
      handler?.(data.data)
      microApp.clearData(name!)
    }

    if (name) microApp.addDataListener(name, dataHandler)
    return () => {
      if (name) microApp.removeDataListener(name, dataHandler)
    }
  }, [instance])

  if (loading) {
    return (
      <Layout className={styles.loadingContainer}>
        <Loading tip="Loading..." />
      </Layout>
    )
  }

  return (
    <Layout className={styles.layout}>
      <Layout.Header className={styles.header}>
        <div className={styles.headerLeft}>
          <Logo className={styles.logo} />
          <h1 className={styles.title}>数字化资产平台</h1>
        </div>
        <div className={styles.headerRight}>
          <span className={styles.menuItem}>工作台</span>
        </div>
      </Layout.Header>

      <Layout>
        <Layout.Sider className={styles.sider} width={190} collapsed={collapsed} collapsedWidth={72}>
          <div className={styles.siderContent}>
            <div className={styles.siderHeader}>
              <span className={styles.collapseButton} onClick={toggle}>
                {collapsed ? <MenuUnfoldOutlined /> : <MenufoldOutlined />}
              </span>
            </div>
            <Steps
              items={items}
              className={styles.steps}
              current={current}
              onChange={setCurrent}
              progressDot
              direction="vertical"
            />
          </div>
        </Layout.Sider>
        <Layout.Content className={styles.content}>
          {instance && (
            <micro-app
              id="MAIN_CONTENT_CONTAINER"
              name={instance.nodeConfig.name}
              url={normalizedUrl}
              iframe={instance.nodeConfig.iframe}
              default-page={instance.nodeConfig.defaultPage}
              data={microData}
              keep-alive
            />
          )}
        </Layout.Content>
      </Layout>
      <Layout.Footer id="LAYOUT_APP_FOOTER" className={styles.footer}></Layout.Footer>
    </Layout>
  )
}

export default CreateApp
